import { render, staticRenderFns } from "./ForgotUsername.vue?vue&type=template&id=ab06b89c&scoped=true&"
import script from "./ForgotUsername.vue?vue&type=script&lang=js&"
export * from "./ForgotUsername.vue?vue&type=script&lang=js&"
import style0 from "./ForgotUsername.vue?vue&type=style&index=0&id=ab06b89c&lang=scss&scoped=true&"
import style1 from "./ForgotUsername.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab06b89c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
